import SettingsInputAntennaIcon from '@mui/icons-material/SettingsInputAntenna';

export { ChannelList } from './List';
export { ChannelShow } from './Show';
export { ChannelEdit } from './Edit';
export { ChannelCreate } from './Create';
export const ChannelIcon = SettingsInputAntennaIcon;
